module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "UserViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.active == true ? 'Active' : 'Inactive'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.emailnotif == true ? 'Email Alerts Enabled' : 'Email Alerts Disabled'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.chat == true ? 'Wire is Enabled' : 'Wire is Disabled'))]), _vm._v(" "), _vm._l((_vm.roles), function(r) {
    return _c('div', [(r['.key'] == _vm.user.role) ? _c('p', [_vm._v(_vm._s(r.name))]) : _vm._e()])
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "UserEditing col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Active",
      "name": "active"
    },
    model: {
      value: (_vm.userEdit.active),
      callback: function($$v) {
        _vm.$set(_vm.userEdit, "active", $$v)
      },
      expression: "userEdit.active"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Wire")]), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Wire",
      "name": "chat"
    },
    model: {
      value: (_vm.userEdit.chat),
      callback: function($$v) {
        _vm.$set(_vm.userEdit, "chat", $$v)
      },
      expression: "userEdit.chat"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-select', {
    attrs: {
      "label": "Role",
      "name": "role",
      "options": _vm.roles
    },
    model: {
      value: (_vm.userEdit.role),
      callback: function($$v) {
        _vm.$set(_vm.userEdit, "role", $$v)
      },
      expression: "userEdit.role"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44815e85","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users/UserDetail.vue
// module id = 618
// module chunks = 1